import React from 'react'
import { Route, IndexRoute } from 'react-router'

import App from './components/App'
import Greetings from './components/Greetings'
import LoginPage from './components/login/LoginPage'
import ResetPassPage from './components/login/ResetPassPage'
import UserdataPage from './components/userdata/UserdataPage'
import OrderPage from './components/order/OrderPage'
import EditOrderPage from './components/order/EditOrderPage'
import CreateOrderPage from './components/order/CreateOrderPage'
import SmetaPage from './components/smeta/SmetaPage'
import AvansPage from './components/avans/AvansPage'
import InvoicePage from './components/invoice/InvoicePage'
import CalendarPage from './components/calendar/CalendarPage'
import KanbanPage from './components/kanban/KanbanPage'
import ExpensePage from './components/expense/ExpensePage'
import MyTodos from './components/todo/MyTodos'
import TodosAll from './components/todo/TodosAll'
import PaymentPage from './components/payment/PaymentPage'
import SetsComp from './components/settings/SetsComp'
import SetsSrvc from './components/settings/SetsSrvc'
import SetsSrvg from './components/settings/SetsSrvg'
import SetsSrvm from './components/settings/SetsSrvm'
import SetsCtype from './components/settings/SetsCtype'
import SetsEtype from './components/settings/SetsEtype'
import SetsProduct from './components/settings/SetsProduct'
import SetsPlace from './components/settings/SetsPlace'
import SetsPtype from './components/settings/SetsPtype'
import SetsStts from './components/settings/SetsStts'
import SetsPerc from './components/settings/SetsPerc'
import SetsRequ from './components/settings/SetsRequ'
import SetsTodolist from './components/settings/SetsTodolist'
import SetsFiletype from './components/settings/SetsFiletype'
import SetsSakh from './components/settings/SetsSakh'
import SetsAction from './components/settings/SetsAction'
import SetsRight from './components/settings/SetsRight'
import SetsUser from './components/settings/SetsUser'
import SetsUsrg from './components/settings/SetsUsrg'
import SetsCompright from './components/settings/SetsCompright'
import Payments from './components/reports/payments/Payments'
import Income from './components/reports/Income'
import Abc from './components/reports/Abc'

import requireAuth from './utils/requireAuth'

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Greetings} />
    <Route path="login" component={LoginPage} />
    <Route path="forgot_pass" component={ResetPassPage} />
    <Route path="userdata" component={requireAuth(UserdataPage)} />
    <Route path="order" component={requireAuth(OrderPage)} />
    <Route path="calendar" component={requireAuth(CalendarPage)} />
    <Route path="kanban" component={requireAuth(KanbanPage)} />
    <Route path="expense" component={requireAuth(ExpensePage)} />
    <Route path="mytodos" component={requireAuth(MyTodos)} />
    <Route path="todosall" component={requireAuth(TodosAll)} />
    <Route path="payment" component={requireAuth(PaymentPage)} />
    <Route path="order/edit" component={requireAuth(EditOrderPage)} />
    <Route path="order/create" component={requireAuth(CreateOrderPage)} />
    <Route path="smeta" component={requireAuth(SmetaPage)} />
    <Route path="avans" component={requireAuth(AvansPage)} />
    <Route path="invoice" component={requireAuth(InvoicePage)} />
    <Route path="sets_comp" component={requireAuth(SetsComp)} />
    <Route path="sets_srvc" component={requireAuth(SetsSrvc)} />
    <Route path="sets_srvg" component={requireAuth(SetsSrvg)} />
    <Route path="sets_srvm" component={requireAuth(SetsSrvm)} />
    <Route path="sets_ctype" component={requireAuth(SetsCtype)} />
    <Route path="sets_etype" component={requireAuth(SetsEtype)} />
    <Route path="sets_product" component={requireAuth(SetsProduct)} />
    <Route path="sets_place" component={requireAuth(SetsPlace)} />
    <Route path="sets_ptype" component={requireAuth(SetsPtype)} />
    <Route path="sets_stts" component={requireAuth(SetsStts)} />
    <Route path="sets_perc" component={requireAuth(SetsPerc)} />
    <Route path="sets_requ" component={requireAuth(SetsRequ)} />
    <Route path="sets_todolist" component={requireAuth(SetsTodolist)} />
    <Route path="sets_filetype" component={requireAuth(SetsFiletype)} />
    <Route path="sets_sakhice" component={requireAuth(SetsSakh)} />
    <Route path="sets_action" component={requireAuth(SetsAction)} />
    <Route path="sets_right" component={requireAuth(SetsRight)} />
    <Route path="sets_user" component={requireAuth(SetsUser)} />
    <Route path="sets_usrg" component={requireAuth(SetsUsrg)} />
    <Route path="sets_compright" component={requireAuth(SetsCompright)} />
    <Route path="payments" component={requireAuth(Payments)} />
    <Route path="income" component={requireAuth(Income)} />
    <Route path="abc" component={requireAuth(Abc)} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js